export default __webpack_public_path__ + "static/media/0000BLEU.148c2055.pdf";